module.exports = __webpack_public_path__ + "img/tiktok.629f274a.png";